import { useState, useEffect } from 'react'
import { WhichWeightAPI } from 'WhichWeightAPI'
import moment from 'moment'

import ContentFrame from 'components/Frame/ContentFrame'

export default function AthleteAppStripeCancellationSurveyTab() {

    const athleteCancellationSurveyOptions = [
        {
            id: 1,
            key: 'direction',
            text: 'The app is hard to use',
        },
        {
            id: 2,
            key: 'direction',
            text: 'I do not like the exercises',
        },
        {
            id: 3,
            key: 'direction',
            text: 'Inaccurate weight recommendations',
        },
        {
            id: 4,
            key: 'direction',
            text: 'I completed my race / the program ended',
        },
        {
            id: 5,
            key: 'accountability',
            text: 'I do not have time to strength train',
        },
        {
            id: 6,
            key: 'encouragement',
            text: 'I am not motivated to keep training',
        },
        {
            id: 7,
            key: 'community',
            text: 'It is difficult to share my progress',
        },
        {
            id: 8,
            key: 'results',
            text: 'The training is ineffective',
        },
        {
            id: 9,
            key: 'results',
            text: 'I got injured',
        },
        {
            id: 10,
            key: 'budget',
            text: 'Too expensive',
        },
        {
            id: 11,
            key: 'other',
            text: 'Other',
        },
    ]

    const [feedbackData, setFeedbackData] = useState(null)

    const GetUserFeedbackFromBackend = async () => {

        const jsonBody = {
            source: 'cancellation'
        }

        // console.log(jsonBody)

        const result = await WhichWeightAPI('REPORTING', 'GET', '/all_user_feedback', jsonBody)

        // console.log(result)

        setFeedbackData(result.data.data)
    }

    const OpenAthleteProfileInNewTab = (athleteId) => {
        const url = `/athlete/${athleteId}`
        window.open(url, '_blank')
    }

    useEffect(() => {
        GetUserFeedbackFromBackend()
    }, [])

    if (feedbackData === null) {
        return (
            <>
                <div className='w-full h-[800px] bg-gray-200 rounded-lg animate-pulse' />
            </>
        )
    }

    return (
        <div className='space-y-1'>
            <div className='grid grid-cols-6'>
                <p className='text-center text-sm text-gray-500'>Athlete</p>
                <p className='text-center text-sm text-gray-500'>Status upon cancel</p>
                <p className='text-center text-sm text-gray-500'>Survey options</p>
                <p className='text-center text-sm text-gray-500'>Note</p>
                <p className='text-center text-sm text-gray-500'>Period End Date</p>
                <p className='text-center text-sm text-gray-500'>Date</p>
            </div>

            <ContentFrame>
                <div className="text-center divide-y divide-gray-200">
                    {feedbackData.map((feedback) => (
                        <div 
                            key={feedback.id} 
                            className="grid grid-cols-6 divide-x divide-gray-200"
                        >
                            <div 
                                className="p-2 space-y-1 overflow-x-auto cursor-pointer hover:bg-gray-100"
                                onClick={() => OpenAthleteProfileInNewTab(feedback.userId)}
                            >
                                <div className='text-sm'>{feedback.firstName} {feedback.lastName}</div>
                                <div className='text-xs text-gray-500'>{feedback?.email?.length > 0 ? feedback.email : 'No Email'}</div>
                            </div>

                            <div className="flex items-center justify-center p-2 text-sm">
                                {JSON.parse(feedback.detailsJSON)['statusUponCancellation']}
                            </div>
                            
                            {Array.isArray(JSON.parse(feedback.detailsJSON).selectedSurveyOptions) && (
                                <div className="p-2 space-y-1">
                                    {JSON.parse(feedback.detailsJSON).selectedSurveyOptions.map((option) => (
                                        <div 
                                            key={option}
                                            className='text-sm'
                                        >
                                            - {athleteCancellationSurveyOptions.find((item) => item.id === option).text}
                                        </div>
                                    ))}
                                </div>
                            )}
                            
                            <div className="flex items-center justify-center p-2 text-sm">
                                {feedback.additionalNote}
                            </div>

                            <div className="flex items-center justify-center p-2 text-sm">
                                {moment.utc(JSON.parse(feedback.detailsJSON)['periodEndDate']).local().format('MMMM DD, YYYY')}
                            </div>
                            
                            <div className="flex items-center justify-center p-2 text-sm">
                                {moment.utc(feedback.createdDate).local().format('MMMM DD, YYYY hh:mm A')}
                            </div>
                        </div>
                    ))}
                </div>
            </ContentFrame>
        </div>
    )
}